import $ from 'jquery';
import { insightsPageSliderConfig } from './sliders-config';

export default function initInsightsPageSlider() {
  if ($('.slider--insights')) {
    const config = insightsPageSliderConfig();

    $('.slider--insights').slick(config);
  }
}
